const ESTIMATE_OLD_AFTER_MS = 7 * 24 * 60 * 60 * 1000;

export default {
  isEstimateReceivingStopped(item) {
    return Boolean(
      item &&
        item.requestType === "comparison" &&
        item.receivingEnabled === false
    );
  },
  isEstimateOld(item) {
    const rawCreatedAt = item && item.createdAt;
    if (!rawCreatedAt) return false;

    const createdAt = new Date(rawCreatedAt).getTime();
    return (
      Number.isFinite(createdAt) &&
      Date.now() - createdAt >= ESTIMATE_OLD_AFTER_MS
    );
  },
  estimateTitle(item) {
    if (item.requestType === "comparison") {
      return item.category || "웨딩밴드 비교 견적";
    }
    if (item.requestType === "product") {
      return (
        item.productName || (item.product && item.product.name) || "상품 견적"
      );
    }
    return item.category || "-";
  },
  estimateMaterial(item) {
    if (item.requestType === "product" || item.requestType === "comparison") {
      return item.budgetRange || "-";
    }
    return item.material || "-";
  },
  estimateSize(item) {
    if (item.requestType === "product" || item.requestType === "comparison") {
      return item.desiredPrice || "-";
    }
    return item.size || "-";
  },
};
